/* ============================================
   BOTANE HOMEPAGE — JavaScript
   Feather/Horizon Cart Integration
   ============================================ */

(function () {
  'use strict';

  /* --- Currency Formatting --- */

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active
      : 'USD';

    var amount = (cents / 100).toFixed(2);

    var config = {
      'USD': { symbol: '$',    before: true,  decimal: '.' },
      'CAD': { symbol: 'CA$',  before: true,  decimal: '.' },
      'AUD': { symbol: 'A$',   before: true,  decimal: '.' },
      'GBP': { symbol: '£',    before: true,  decimal: '.' },
      'EUR': { symbol: '€',    before: false, decimal: ',' },
      'CHF': { symbol: 'CHF',  before: true,  decimal: '.' },
      'SEK': { symbol: 'kr',   before: false, decimal: ',' },
      'DKK': { symbol: 'kr',   before: false, decimal: ',' },
      'NOK': { symbol: 'kr',   before: false, decimal: ',' }
    };

    var fmt = config[currency] || { symbol: currency, before: true, decimal: '.' };
    var formatted = amount.replace('.', fmt.decimal);

    return fmt.before
      ? fmt.symbol + formatted
      : formatted + '\u00a0' + fmt.symbol;
  }

  /* --- Cart Integration (same pattern as PDP) --- */

  function dispatchCartUpdate(itemCount) {
    var event = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {},
        sourceId: 'botane-hp',
        data: {
          source: 'product-form-component',
          itemCount: itemCount
        }
      }
    });
    document.dispatchEvent(event);
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else if (drawer && typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  function afterAddToCart(quantity) {
    var qty = quantity || 1;
    dispatchCartUpdate(qty);
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && !drawer.hasAttribute('auto-open')) {
      openCartDrawer();
    }
  }

  function addToCart(variantId, quantity, button) {
    if (!variantId) return;

    var qty = quantity || 1;
    var originalText = button ? button.textContent : '';

    if (button) {
      button.setAttribute('data-adding', 'true');
      button.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (button) {
            button.textContent = data.description || 'Error';
            setTimeout(function () { button.textContent = originalText; }, 3000);
          }
          return;
        }
        if (button) {
          button.textContent = 'ADDED \u2713';
          setTimeout(function () { button.textContent = originalText; }, 2000);
        }
        afterAddToCart(qty);
      })
      .catch(function () {
        if (button) { button.textContent = originalText; }
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('data-adding');
          button.disabled = false;
        }
      });
  }

  function addMultipleToCart(items, button) {
    if (!items || items.length === 0) return;

    var originalText = button ? button.textContent : '';

    if (button) {
      button.setAttribute('data-adding', 'true');
      button.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (button) {
            button.textContent = data.description || 'Error';
            setTimeout(function () { button.textContent = originalText; }, 3000);
          }
          return;
        }
        if (button) {
          button.textContent = 'ADDED \u2713';
          setTimeout(function () { button.textContent = originalText; }, 2000);
        }
        afterAddToCart(items.length);
      })
      .catch(function () {
        if (button) { button.textContent = originalText; }
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('data-adding');
          button.disabled = false;
        }
      });
  }

  /* --- Quick-Add (Core Ritual) --- */

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-botane-hp-quick-add]');
      if (!btn) return;
      var variantId = btn.getAttribute('data-variant-id');
      addToCart(variantId, 1, btn);
    });
  }

  /* --- Routine Builder --- */

  function initRoutineBuilder() {
    var section = document.querySelector('.botane-hp-routine-builder');
    if (!section) return;

    var steps = section.querySelectorAll('.botane-hp-ritual-step');
    var totalEl = section.querySelector('[data-ritual-total]');
    var addAllBtn = section.querySelector('.botane-hp-routine-builder__add-all');

    function updateTotal() {
      var total = 0;
      var activeIds = [];

      steps.forEach(function (step) {
        if (step.getAttribute('data-included') === 'true') {
          total += parseInt(step.getAttribute('data-price') || '0', 10);
          var vid = step.getAttribute('data-variant-id');
          if (vid) activeIds.push(vid);
        }
      });

      if (totalEl) {
        totalEl.textContent = formatMoney(total);
      }

      if (addAllBtn) {
        addAllBtn.setAttribute('data-variant-ids', activeIds.join(','));
        addAllBtn.disabled = activeIds.length === 0;
      }
    }

    /* Checkbox toggle */
    steps.forEach(function (step) {
      var checkbox = step.querySelector('.botane-hp-ritual-step__checkbox');
      if (!checkbox) return;

      checkbox.addEventListener('click', function () {
        var included = step.getAttribute('data-included') === 'true';
        step.setAttribute('data-included', included ? 'false' : 'true');
        step.classList.toggle('botane-hp-ritual-step--dimmed', included);
        updateTotal();
      });
    });

    /* Add All to Bag */
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        var ids = (addAllBtn.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
        if (ids.length === 0) return;

        var items = ids.map(function (id) {
          return { id: parseInt(id, 10), quantity: 1 };
        });

        addMultipleToCart(items, addAllBtn);
      });
    }

    /* Initial calculation */
    updateTotal();
  }

  /* --- Init --- */

  function init() {
    initQuickAdd();
    initRoutineBuilder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();